/**
 * Set a session storage item
 * @param key - The key to set
 * @param value - The value to set
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export function setSessionStorageItem(key: string, value: string) {
	if (typeof window === "undefined") return;
	sessionStorage.setItem(key, value);
}

/**
 * Get a session storage item
 * @param key - The key to get
 * @returns The value of the item
 */
export function getSessionStorageItem(key: string) {
	if (typeof window === "undefined") return "";
	return sessionStorage.getItem(key) || "";
}

/**
 * Delete a session storage item
 * @param key - The key to delete
 */
export function deleteSessionStorageItem(key: string) {
	if (typeof window === "undefined") return;
	sessionStorage.removeItem(key);
}
